// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminPage_container__2Z6Sg"};